import { DynamicSupplyHardware, SimpleClusterForm } from "@/types";
import { SavedDeploymentConfigKind } from "@/types/savedDeploymentConfig";
import { toSavedPayload } from "@/utils/savedDeploymentConfig";

/** Minimum fields for a reusable saved config (not an empty form). */
export const canSaveDeploymentConfig = (
  values: SimpleClusterForm,
  kind: SavedDeploymentConfigKind
): boolean => {
  if (!values.hardware) return false;

  if (kind === "container") {
    if (!values.containerImage?.trim()) return false;
    if (
      values.trafficPort === undefined ||
      values.trafficPort === null ||
      String(values.trafficPort).trim() === ""
    ) {
      return false;
    }
    if (values.isPrivate) {
      if (!values.username?.trim() || !values.secret?.trim()) return false;
    }
    return true;
  }

  // VM
  if (values.supplier !== "external" && !values.vmImageType) return false;
  const hasSelectedKeys = (values.selectedSshKeyIds?.length ?? 0) > 0;
  const hasValidSshKey =
    hasSelectedKeys ||
    (values.sshKeys ?? []).some(
      (sshKey) => Boolean(sshKey.key?.trim()) && Boolean(sshKey.value?.trim())
    );
  return hasValidSshKey;
};

export const buildSavePayload = (
  values: SimpleClusterForm,
  kind: SavedDeploymentConfigKind,
  hardware?: DynamicSupplyHardware | null
) => toSavedPayload(values, kind, hardware);
